import { DESKTOP } from "@/themes/device";
import styled from "@emotion/styled";

export const DefaultWrapper = styled.section`
  padding: 100px 0;
  ${DESKTOP} {
    padding: 120px 0;
  }
`;

export const Benefits = styled(DefaultWrapper)`
  background-color: #f1f4ff;
`;

export const Study = styled(DefaultWrapper)`
  background-color: #ffffff;
`;

export const Brands = styled(DefaultWrapper)`
  background-color: #ffffff;
`;
